var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button-group',{staticClass:"d-flex",style:(_vm.groupStyles),attrs:{"size":_vm.size}},_vm._l((_vm.regionsmanagers),function(regionsmanager){return _c('b-button',{key:regionsmanager,attrs:{"id":regionsmanager,"variant":_vm.isRegionsmanagersSelected(regionsmanager)
        ? 'primary'
        : _vm.value.length === 0 && regionsmanager === 'Alle'
        ? 'primary'
        : ''},on:{"click":function($event){return _vm.regionsmanagerClicked(regionsmanager)}}},[_vm._v(" "+_vm._s(regionsmanager)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }